<template>
    <div class="xg-pwd-wrap">
        <div class="pwd-wrap">
            <div class="pwd-close" @click="closeEditPassDom"></div>
            <div class="pwd-wrap-th">修改密码</div>
            <div class="pwd-wrap-tb">
                <div class="pwd-lt">原密码:</div>
                <input type="password" v-model="password0" class="pwd-rt"/>
            </div>
            <div class="pwd-wrap-tb">
                <div class="pwd-lt">新密码:</div>
                <input type="password" v-model="password1" class="pwd-rt"/>
            </div>
            <div class="pwd-wrap-tb">
                <div class="pwd-lt">确认密码:</div>
                <input type="password" v-model="password2" class="pwd-rt"/>
            </div>
            <div class="pwd-wrap-btn">
                <span class="pwd-btn" @click="saveEditPass">修改</span>
                <span class="pwd-btn cancelpwd" @click="closeEditPassDom">取消</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BaseHeaderEditPass",
        methods: {
            closeEditPassDom() {
                this.$emit('closeEditPass', true);
            },
            saveEditPass() {
                if(this.password0 === '' || this.password1 === '' || this.password2 === '') {
                    this.$message.error('密码不能为空');
                    return false;
                }
                if(this.password1 !== this.password2) {
                    this.$message.error('两次密码不一样');
                    return false;
                }
                this.$api.setpasswd(this.password0, this.password1, this.$store.state.now_token, this.$store.state.now_trade_account).then(res => {
                    if(res.data.code === 200) {
                        this.$message({
                            message: res.data.data,
                            type: 'success'
                        });
                    } else {
                        this.$message.error(res.data.msg)
                    }
                    this.$emit('closeEditPass', 'suc');
                })
            }
        },
        data: function () {
            return {
                password0: "",
                password1: "",
                password2: ""
            }
        }
    }
</script>

<style scoped>
    .pwd-wrap {
        padding-bottom: 20px;
    }
</style>
